<script>
import dialog2Mixin from "../mixins/dialog2";

export default {
  components: {
    ContentPrivacy: () => import("@components/Content/ContentPrivacy"),
  },
  mixins: [dialog2Mixin],
}
</script>
<!-- section template -->
<template>
  <el-dialog
    :visible.sync="dialog2MixinVisible"
    :custom-class="`${ $style.dialogPrivacy } isStyleBase text-center`"
    width="1300px"
    append-to-body
    @closed="$Dialog2MixinOnDestroy"
  >
    <h1 class="dialogPrivacy__title">使用細則＆隱私權條款</h1>
    <ContentPrivacy/>
  </el-dialog>
</template>
<!-- section style -->
<style lang="scss" module>
.dialogPrivacy {
  :global {
    .dialogPrivacy {
      &__title {
        margin-bottom: 3rem;
        font-size: 2rem;

        @include max-md {
          font-size: 1.5rem;
        }
      }
    }
  }
}
</style>
